"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormNestedInlineTableField = void 0;
const form_field_1 = require("./form-field");
const nested_inline_table_field_1 = require("../../../components/nested-inline-table-field/nested-inline-table-field");
exports.FormNestedInlineTableField = form_field_1.formFieldFactory(nested_inline_table_field_1.NestedInlineTableField);
//# sourceMappingURL=form-inline-nested-table-field.js.map